import { configureStore, Middleware as ReduxMiddleware } from '@reduxjs/toolkit'
import reducers from './reducersCombiner'
import { createLogger } from 'redux-logger'
import environment from '../config'

const middlewares: ReduxMiddleware[] = []

if (environment.debugEnabled) {
  const logger = createLogger({
    collapsed: (_, __, logEntry) => !logEntry?.error,
  })

  middlewares.push(logger)
}

export const store = configureStore({
  reducer: reducers,
  middleware: (getDefault) =>
    getDefault({ immutableCheck: false, serializableCheck: false }).concat(middlewares),
  devTools: environment.debugEnabled,
})
